const config = {
  app: {
    version: '0.1.0'
  },
  apiRoot: window.__env.mheEnv === 'local' ? `http://localhost:${process.env.PORT || '8200'}/v1` : window.__env.mheEnv === 'prod' ? 'https://am-api-prod.accessmanager.prod.mheducation.com/v1' : `https://am-api-${window.__env.mheEnv}.accessmanager.nonprod.mheducation.com/v1`,
  apiRootV2: window.__env.mheEnv === 'local' ? `http://localhost:${process.env.PORT || '8200'}/v2` : window.__env.mheEnv === 'prod' ? 'https://am-api-prod.accessmanager.prod.mheducation.com/v2' : `https://am-api-${window.__env.mheEnv}.accessmanager.nonprod.mheducation.com/v2`,
  dataBrowser: window.__env.mheEnv === 'prod' ? 'https://access-support.mheducation.com' : `https://access-support-${window.__env.mheEnv}.mheducation.com`,
  env: window.__env.mheEnv,
  localization: {
    filePrefix: '/locales/',
    fileSuffix: '.json',
    defaultLanguage: 'en_US'
  },
  storage: {
    prefix: 'dimsum',
    storageType: 'sessionStorage'
  },
  pageLoader: {
    minDisplayTime: 1000,
    maxDisplayTime: 30000
  },
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=0, post-check=0, pre-check=0',
    'Expires': '-1',
    'Pragma': 'no-cache'
  },
  sso: {
    backRedirectURL: window.__env.mheEnv === 'prod' || !window.__env.mheEnv ? 'https://my.mheducation.com/' : `https://my-${window.__env.mheEnv}.mheducation.com`,
    loginURL: window.__env.mheEnv === 'prod' || !window.__env.mheEnv ? 'https://my.mheducation.com/api/logout' : `https://my-${window.__env.mheEnv}.mheducation.com/api/logout`,
  },
  contact: {
    integrationSupport: 'integrationsupport@mheducation.com'
  },
  helpDocLink: 'https://mhedu.force.com/DTS/s/article/Access-Manager-Help'

};

export default config;



// WEBPACK FOOTER //
// ./app/app.config.js